"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clone = clone;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
